import { api } from "@/lib/api"
import type {
  HistoryParams,
  HistoryResponse,
  LeaderboardParams,
  LeaderboardResponse,
  PointsBalance,
  RedeemInput,
  Redemption,
  Reward,
} from "../types"

const ENDPOINTS = {
  BALANCE: "/points/balance",
  HISTORY: "/points/history",
  LEADERBOARD: "/points/leaderboard",
  REWARDS: "/points/rewards",
  REDEEM: "/points/redeem",
  MY_REDEMPTIONS: "/points/my-redemptions",
} as const

function buildQuery(params?: HistoryParams | LeaderboardParams | { status?: string }) {
  if (!params) return ""
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) search.set(key, String(value))
  }
  const qs = search.toString()
  return qs ? `?${qs}` : ""
}

export const pointsService = {
  getBalance: () => api.get<PointsBalance>(ENDPOINTS.BALANCE),

  getHistory: (params?: HistoryParams) =>
    api.get<HistoryResponse>(`${ENDPOINTS.HISTORY}${buildQuery(params)}`),

  getLeaderboard: (params?: LeaderboardParams) =>
    api.get<LeaderboardResponse>(`${ENDPOINTS.LEADERBOARD}${buildQuery(params)}`),

  getRewards: () => api.get<{ rewards: Reward[] }>(ENDPOINTS.REWARDS),

  redeem: (input: RedeemInput) => api.post<Redemption>(ENDPOINTS.REDEEM, input),

  getMyRedemptions: (params?: { status?: string }) =>
    api.get<{ redemptions: Redemption[] }>(
      `${ENDPOINTS.MY_REDEMPTIONS}${buildQuery(params)}`,
    ),
}
